import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CartOrder } from '../../../../../../../../core/models/order.model';
import { CustomCartSharedModule } from '../../../../../../cart/base/components/cart-shared';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'review-items',
  standalone: true,
  imports: [CommonModule, CustomCartSharedModule, I18nModule],
  templateUrl: './review-items.component.html',
  styleUrl: './review-items.component.scss',
})
export class ReviewItemsComponent {
  @Input() cartOrder!: CartOrder;
  @Input() readonly = true;
  @Input() displayDates = true;
  @Input() displayValues = true;
}
